import { useMemo } from 'react'

import { y } from '@circlefin/form'
import { L3OnboardingProduct } from '@shared/graphql'
import useTranslation from 'next-translate/useTranslation'

import { requiredMessage } from '../../../yup/utils'
import { L3OnboardingMultiSelectCombobox } from '../../L3OnboardingMultiSelectCombobox'

import type { L3OnboardingMultiSelectComboboxVariantProps } from '../types'
import type { MultiSelectComboboxItem } from '@circlefin/components/lib/MultiSelectCombobox'

export const circleProductsSchema = y
  .array()
  .of(y.mixed<L3OnboardingProduct>())
  .min(1, requiredMessage)

export const CircleProducts: React.FC<
  L3OnboardingMultiSelectComboboxVariantProps
> = (props) => {
  const { t } = useTranslation('l3Onboarding')

  const items: Array<MultiSelectComboboxItem<L3OnboardingProduct>> = useMemo(
    () =>
      Object.values(L3OnboardingProduct).map((product) => ({
        label: t(
          `forms.intendedUseOfAccount.expectedProductsForUsage.options.${L3OnboardingProduct[product]}`,
        ),
        value: L3OnboardingProduct[product],
      })),
    [t],
  )

  return (
    <L3OnboardingMultiSelectCombobox
      items={items}
      label={t`forms.intendedUseOfAccount.expectedProductsForUsage.label`}
      {...props}
    />
  )
}
